var rUpper = /([A-Z])/g;
export default function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-overlays/node_modules/dom-helpers/esm/hyphenate.js
// module id = 1175
// module chunks = 0